import { FormControl, FormHelperText, FormLabel, MenuItem, Select, Typography } from '@mui/material';
import * as React from 'react';


export default function CustomSelect({ values, onChange, error, data, title, required, disabled, placeholder, subtitle, icon, name, valueName, labelName, width, height, noBorderRadius, sx, ableClear = true }) {
    return (
        <>
            <FormControl variant="outlined" fullWidth={width ? false : true}>
                <FormLabel style={{ fontFamily: 'Manrope-SemiBold', fontSize: 14 }}>{title}{required && <span style={{ color: "red" }}>*</span>}</FormLabel>
                <Select
                    size="small"
                    value={values}
                    name={name}
                    required={required}
                    disabled={disabled}
                    displayEmpty
                    sx={sx && sx}
                    placeholder={placeholder || 'Choose'}
                    onChange={(e) => onChange(e.target.value)}
                    style={{ color: (values === "" || values === "-1") ? "#c8c8c8" : 'inherit', width: width && width, height: height && height, borderRadius: noBorderRadius && 0 }}
                    IconComponent={() => (
                        ableClear ? (values === '-1' || !values) ? <i className="ri-expand-up-down-line mx-2" style={{ color: '#101010' }} /> : <i className="ri-close-line mx-2" style={{ color: '#101010', cursor: 'pointer' }} onClick={() => { onChange('') }} /> : <i className="ri-expand-up-down-line mx-2" style={{ color: '#101010' }} />
                    )}
                >
                    <MenuItem style={{ display: "none" }} key={""} value="-1" disabled>{placeholder}</MenuItem>
                    <MenuItem style={{ display: "none" }} key={"all"} value="all" disabled>{placeholder}</MenuItem>
                    {
                        data?.length > 0 ? data.map((x, idx) =>
                            <MenuItem key={idx}
                                value={x[`${valueName}`] || x.value || x.id}
                                style={{
                                    backgroundColor: (x[`${valueName}`] || x.value || x.id) === values ? '#ED1A3D0D' : 'white',
                                    color: (x[`${valueName}`] || x.value || x.id) === values ? '#ED1A3D' : '#101010'
                                }}
                            >
                                {
                                    icon ?
                                        <Typography><i className={`${x?.icon} p-2`} style={{ marginRight: x?.icon?.includes("fa") && 12 }}></i> {x[`${labelName}`] || x.label || x.name}</Typography>
                                        :
                                        (labelName && x[`${labelName}`]) || x.label || x.name
                                }
                            </MenuItem>
                        ) :
                            <MenuItem disabled>No options available</MenuItem>
                    }
                </Select>
                <span style={{ fontSize: 13, color: '#74788D', marginTop: '5px', fontWeight: '300' }}>{subtitle}</span>
            </FormControl>
            {error && <FormHelperText sx={{ color: "red" }}>{error || ""}</FormHelperText>}

        </>


    );
}
